/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

// Mirror interactions between collection sorting on desktop (custom, not attached to Pipeline sort class) and mobile (Pipeline default)
function collectionSorting() {
  if (document.body.classList.contains('template-collection')) {

    const $label = document.querySelector('.sb-collection-sort-desktop [data-sort-button-text]');
    const $items = document.querySelectorAll('.sb-collection-sort-desktop .popout-list__item');
    const $trueSort = document.querySelector('.collection__nav .collection__sort');
    const $trueLabel = $trueSort.querySelector('[data-sort-button-text]');

    $items.forEach(function ($i) {
      const $option = $i.querySelector('.popout-list__option');
      $option.addEventListener('click', function (e) {
        e.preventDefault();
        const val = this.getAttribute('data-value');
        const $trueOpt = $trueSort.querySelector('.popout-list__option[data-value="'+val+'"]');
        $trueOpt.click();
        $label.innerText = $trueLabel.innerText;
        $items.forEach(function ($i2) {
          $i2.classList.remove('popout-list__item--current');
        });
        $i.classList.add('popout-list__item--current');
      });
    });

  }
}


(function() {
  
  // init
  collectionSorting()

  $('.model-product-toggle__wrapper button').click(function (e) {
    e.preventDefault();

    $('.model-product-toggle__wrapper button').removeClass('active');
    $(this).addClass('active');

    if($(this).hasClass('model-btn')) {
      $('.modeled-media__wrapper').addClass('active');
      $('.modeled-media__wrapper').removeClass('inactive');
      $('.product-media__wrapper').addClass('inactive');
      $('.product-media__wrapper').removeClass('active');
    } else {
      $('.product-media__wrapper').addClass('active');
      $('.product-media__wrapper').removeClass('inactive');
      $('.modeled-media__wrapper').addClass('inactive');
      $('.modeled-media__wrapper').removeClass('active');
    }
  });
})();

$(document).ready(function () {
  checkAndAddPrintProofItem();

  $('input[name="attributes[Proof Option]"]').change(function () {
    checkAndAddPrintProofItem();
  });

  // Function to check if the free gift is already in the cart
  function isProofChargeInCart(cartItems, productId) {
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].id === productId) {
        return cartItems[i];
      }
    }
    return null;
  }

  // Function to remove the free gift from the cart
  function removeProofCharge(cartItemId) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: cartItemId,
        quantity: 0
      },
      success: function (response) {
        updateCartAttribute('Proof Option', 'Digital Proof Mockups by Email');
        console.log(response);
        setTimeout(function() { location.reload(); }, 500);
      },
      error: function (error) {
        console.log('Error removing free gift from cart:', error);
      }
    });
  }

  // Update Cart Attribute
  function updateCartAttribute(attributeName, attributeValue) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        attributes: {
          [attributeName]: attributeValue
        }
      },
      dataType: 'json',
      success: function (cart) {
        console.log('Cart attribute updated successfully:', cart);
      },
      error: function (error) {
        console.error('Error updating cart attribute:', error);
      }
    });
  }

  // Get the total quantity of items in the cart
  var totalFrames = 0;
  $('.count_this').each(function () {
    var qty = parseInt($(this).find('.quantity__input').val(), 10);
    if (!isNaN(qty)) {
      totalFrames += qty;
    }
  });

  var proofChargeProductId = parseInt($('.cart__items').data('freegift'));
  console.log(totalFrames + '   ' + proofChargeProductId);

  function checkAndAddPrintProofItem() {
    var selectedProofOption = $('input[name="attributes[Proof Option]"]:checked').val();

    $.getJSON('/cart.js', function (cart) {
      var proofChargeItem = isProofChargeInCart(cart.items, proofChargeProductId);
      var proofChargeQuantity = Math.ceil(totalFrames / 5);

      if (selectedProofOption == 'Print Proof Photos by Email' && totalFrames >= 1) {
        if (!proofChargeItem) {
          // Add proof charge to the cart if it doesn't exist
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
              id: proofChargeProductId,
              quantity: proofChargeQuantity,
              attributes: {
                "Proof Option": selectedProofOption
              }
            },
            success: function (response) {
              console.log(response);
              setTimeout(function() { location.reload(); }, 500);
            },
            error: function (error) {
              console.log('Error adding proof charge to cart:', error);
            }
          });
        } else if (proofChargeItem.quantity !== proofChargeQuantity) {
          // Update proof charge quantity if it exists but the quantity is incorrect
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              id: proofChargeItem.id,
              quantity: proofChargeQuantity
            },
            success: function (response) {
              updateCartAttribute("Proof Option", selectedProofOption);
              console.log(response);
              setTimeout(function() { location.reload(); }, 500);
            },
            error: function (error) {
              console.log('Error updating proof charge in cart:', error);
            }
          });
        } else {
          console.log('Proof charge is already correctly set in the cart.');
        }
      } else if (proofChargeItem) {
        // Remove proof charge from the cart if the total frames are less than 5 or the option is not selected
        removeProofCharge(proofChargeItem.id);
      }
    });
  }


  function checkCheckboxes() {
    var termsChecked = $('input[name="attributes[terms_of_service]"]').is(':checked');
    var privacyChecked = $('input[name="attributes[privacy_policy]"]').is(':checked');
  
    if (termsChecked && privacyChecked) {
      $('.checkout__button').removeClass('disabled').removeAttr('disabled');
    } else {
      $('.checkout__button').addClass('disabled').attr('disabled', 'disabled');
    }
  }

  if($('input[name="attributes[terms_of_service]"]').length && $('input[name="attributes[privacy_policy]"]').length) {
    checkCheckboxes();
  }

  $('input[name="attributes[terms_of_service]"], input[name="attributes[privacy_policy]"]').on('change', function () {
    checkCheckboxes();
  });

  $('.swatch__button label').on('click', function(){
      let choice = $(this).attr('data-swatch').toLowerCase();
      // console.log("choice -->", choice);
      $('.product_thumbnails-grid .product__media').find('img').each(function(){
          let alt = $(this).attr('alt').toLowerCase();
           if(alt.includes(choice)){
               //console.log("alt -->", alt);
            $(this).closest('.swiper-slide').show();
               $(this).closest('.swiper-slide').css('width','');
               
          } else {
            $(this).closest('.swiper-slide').hide();
          }
      });
  });
});
